export const WHEEL_FIELDS = [20, 1, 3, 1, 5, 1, 3, 1, 10, 1, 3, 5, 1, 5, 1, 3, 1, 10, 1, 3, 1, 5, 1, 3, 1]
export const MIN_WHEEL_ROTATIONS = 5
export const INTERLUDE_DURATION = 2500

export const BET_FIELDS = [1, 3, 5, 10, 20]
export const BET_MIN = 1
export const BET_MAX = 99999
export const DEFAULT_SCRAP_STACKS = [1, 10, 50, 100, 500]

export const MOUSE_BUTTON_ACTIONS = {
  0: 'normal',
  1: 'split',
  2: 'single',
}

export const getRotation = el => {
  const match = el.style.transform.match(/rotate\(([-]?\d+(?:\.\d+)?)deg\)/)
  if (match && match[1]) return parseFloat(match[1])
  return 0
}
